export default __webpack_public_path__ + "static/media/B3_12.ccc39bdf.mp3";